<template>
  <div>
    <search-base-module-product @submit="submitSearch" />

    <div class="simiot-table-operation-buttons">
      <a-space>
        <a-button
          type="primary"
          @click="showNewModal"
          v-if="isShowMenu('base_module_products/new')"
        >新增</a-button>

        <update-base-module-product-effective
          v-if="isShowMenu('base_module_products/effective')"
          :selected-row-keys="selectedRowKeys"
          @completed="fetchData"
        />
      </a-space>
    </div>

    <a-table
      size="middle"
      :scroll="{ x: 'max-content' }"
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :pagination="false"
      :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      row-key="id"
    >
      <span slot="actions" slot-scope="text, record">
        <a-dropdown>
          <a class="ant-dropdown-link" @click="e => e.preventDefault()">
            操作 <a-icon type="down" />
          </a>
          <a-menu slot="overlay">
            <a-menu-item v-if="isHasEditPermission">
              <a @click="showEditModal(record.id)">编辑</a>
            </a-menu-item>
            <a-menu-item>
              <a @click="showOperationHistoryModal(record.id)">操作历史</a>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </span>
    </a-table>

    <pagination
      v-show="pagination.total_count > 0"
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchData"
    />

    <new-base-module-product
      v-if="isShowNewModal"
      :visible.sync="isShowNewModal"
      @completed="fetchData"
    />

    <edit-base-module-product
      v-if="isShowEditModal"
      :visible.sync="isShowEditModal"
      :id="editingId"
      @completed="fetchData"
    />

    <operation-history-list-modal
      v-if="isShowOperationHistoryModal"
      :reference-id="showingOperationHistoryId"
      reference-type="BaseModuleProduct"
      :visible.sync="isShowOperationHistoryModal"
    />
  </div>
</template>

<script>
import { hasPermission } from '@/utils/permission'
import { findBaseModuleProducts } from '@/api/base_module_product'
import { formatFloat } from '@/utils/filter'
import Pagination from '@/components/Pagination'
import SearchBaseModuleProduct from '@/views/base_module_products/Search'

export default {
  name: 'BaseModuleProductList',
  components: {
    Pagination,
    SearchBaseModuleProduct,
    NewBaseModuleProduct: () => import('@/views/base_module_products/New'),
    EditBaseModuleProduct: () => import('@/views/base_module_products/Edit'),
    UpdateBaseModuleProductEffective: () => import('@/views/base_module_products/UpdateEffective'),
    OperationHistoryListModal: () => import('@/views/operation_histories/Modal')
  },
  data() {
    return {
      data: [],
      columns: [
        {
          title: '模组厂商',
          dataIndex: 'module_producer_name',
          width: 160
        },
        {
          title: '模组型号',
          dataIndex: 'module_model_name',
          width: 160
        },
        {
          title: '单价(元/片)',
          dataIndex: 'unit_price',
          width: 120,
          customRender: formatFloat
        },
        {
          title: '底价(元/片)',
          dataIndex: 'floor_price',
          width: 120,
          customRender: formatFloat
        },
        {
          title: '有效性',
          dataIndex: 'effective',
          width: 100
        },
        {
          title: '创建时间',
          dataIndex: 'created_at',
          width: 170
        },
        {
          title: '操作',
          width: 100,
          dataIndex: 'actions',
          scopedSlots: { customRender: 'actions' }
        }
      ],
      loading: true,
      selectedRowKeys: [],
      isShowNewModal: false,
      isShowEditModal: false,
      isShowOperationHistoryModal: false,
      showingOperationHistoryId: 0,
      editingId: 0,
      pagination: {
        total_count: 0
      },
      query: { effective: '1' }
    }
  },
  computed: {
    isHasEditPermission() {
      return hasPermission('base_module_products/edit')
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    isShowMenu(menu) {
      return hasPermission(menu)
    },

    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },

    showNewModal() {
      this.isShowNewModal = true
    },

    showEditModal(id) {
      this.editingId = id
      this.isShowEditModal = true
    },

    showOperationHistoryModal(id) {
      this.showingOperationHistoryId = id
      this.isShowOperationHistoryModal = true
    },

    submitSearch(search) {
      this.query = Object.assign({},
        this.$options.data().query,
        { per_page: this.query.per_page },
        search
      )
      this.selectedRowKeys = []
      this.fetchData()
    },

    fetchData() {
      this.loading = true
      findBaseModuleProducts(this.query).then((res) => {
        if (res.code === 0) {
          this.data = res.data
          this.pagination = res.pagination
        }
        this.loading = false
      })
    }
  }
}
</script>
